<template>
  <fieldset :disabled="disabled">
    <div class="logs-container card">
      <div class="logs-header">
        <h2>Logs de Auditoria</h2>
        
        <div class="controls ">
          <div class="search-box">
            <input 
              v-model="searchTerm" 
              type="text" 
              placeholder="Buscar nos logs..."
              class="search-input"
            />
          </div>

          <div class="filters">
            <select v-model="selectedOrigem" class="filter-select">
              <option value="all">Todas as Origens</option>
              <option value="WEB">WEB</option>
              <option value="MODEL">MODEL</option>
              <option value="API">API</option>
            </select>

            <select v-model="selectedEvento" class="filter-select">
              <option value="all">Todos os Eventos</option>
              
              <option value="EDIT_ORCAMENTO_ITEM">Edição de Item</option>
              
              <option value="SALVAR_ORCAMENTO">Edição de Orçamento</option>
              <option value="ALTERAR_IPI_ST_ORCAMENTO">Edição de Orçamento ST IPI</option>

              <option value="NOVO_ORCAMENTO_ITEM">Novo Item</option>
              <option value="CANCELAMENTO_ORCAMENTO">Cancelamento</option>
              <option value="DELETE_ORCAMENTO_ITEM">Item Deletado</option>

              <option value="ATUALIZAR_MARGEM_ST_ITEM">Edição item ST</option>
              <option value="ATUALIZAR_MARGEM_PERCENTUAL_ITEM">Edição item Margem percentual</option>
              <option value="ATUALIZAR_MARGEM_VALOR_ITEM">Edição item Margem Valor</option>
            </select>

            <input 
              v-model="filterUsuarioId" 
              type="text" 
              placeholder="ID do Usuário"
              class="filter-input"
            />
            <input 
              v-model="filterDataInicio" 
              type="date" 
              class="filter-input"
              placeholder="Data Início"
            />

            <input 
              v-model="filterDataFim" 
              type="date" 
              class="filter-input"
              placeholder="Data Fim"
            />

            <button @click="applyFilters" class="btn btn-info">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="m21 21-5.197-5.197m0 0A7.5 7.5 0 1 0 5.196 5.196a7.5 7.5 0 0 0 10.607 10.607Z" />
                </svg>

                Buscar
            </button>
          </div>

          <div class="action-buttons">
  
          <button @click="clearFilters" class="btn btn-warning">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
            Limpar filtros
          </button>

            <button @click="exportLogs" class="btn btn-success">
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="size-6">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 0 0 5.25 21h13.5A2.25 2.25 0 0 0 21 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
                </svg>

              Exportar
            </button>
          </div>
        </div>
      </div>

      <div class="logs-stats">
        <span class="stat">Total: {{ totalRecords }}</span>
      </div>

      <div class="logs-content">
        <div v-if="loading && logs.length === 0" class="loading">
          Carregando logs...
        </div>
        
        <div v-else-if="logs.length === 0" class="no-logs">
          Nenhum log encontrado
        </div>
        
        <div 
          v-for="log in logs" 
          :key="log.id" 
          :class="['log-entry', `origem-${log.origem.toLowerCase()}`]"
        >
          <div class="log-header">
            <span class="log-id">#{{ log.id }}</span>
            <span class="log-time">{{ formatTime(log.criado_em) }}</span>
            <span :class="['log-origem', log.origem.toLowerCase()]" :title=" explicacaoOrigem(log.origem) ">{{ log.origem }}</span>
            <span class="log-evento" :title="log.evento">{{ formatEvento(log.evento) }}</span>
          </div>
          
          <div class="log-info">
            <span class="info-item">
              <strong>Usuário:</strong> {{ log.first_name }}
              <strong>Usuário ID:</strong> {{ log.usuario_id }}
            </span>
          </div>

          <div class="log-message">
            {{ getLogSummary(log) }}
          </div>
          
          <div v-if="log.showDetails" class="log-details">
            <div class="details-header">
              <strong>Contexto Completo:</strong>
            </div>
            <pre>{{ formatContext(log.contexto) }}</pre>
          </div>

          <div v-if="log.showDetails && log.trace" class="log-details">
            <div class="details-header">
              <strong>Trace:</strong>
            </div>
            <pre>{{ formatContext(log.trace) }}</pre>
          </div>
          
          <button 
            @click="toggleDetails(log)" 
            class="btn-toggle-details"
          >
            {{ log.showDetails ? '▲ Ocultar detalhes' : '▼ Ver detalhes' }}
          </button>
        </div>
      </div>

      <div v-if="totalPages > 1" class="pagination">
        <button 
          @click="goToPage(1)" 
          :disabled="currentPage === 1"
          class="btn btn-sm"
        >
          ⏮ Primeira
        </button>
        <button 
          @click="goToPage(currentPage - 1)" 
          :disabled="currentPage === 1"
          class="btn btn-sm"
        >
          ← Anterior
        </button>
        <span class="page-info">
          Página {{ currentPage }} de {{ totalPages }} ({{ totalRecords }} registros)
        </span>
        <button 
          @click="goToPage(currentPage + 1)" 
          :disabled="currentPage === totalPages"
          class="btn btn-sm"
        >
          Próxima →
        </button>
        <button 
          @click="goToPage(totalPages)" 
          :disabled="currentPage === totalPages"
          class="btn btn-sm"
        >
          ⏭ Última
        </button>
        
        <select v-model.number="pageSize" @change="changePageSize" class="page-size-select">
          <option :value="10">10 por página</option>
          <option :value="20">20 por página</option>
          <option :value="50">50 por página</option>
          <option :value="100">100 por página</option>
        </select>
      </div>
    </div>
  </fieldset>
</template>

<script>
  import LogsApi from "../../../services/logs";
export default {
  name: "Logs",
  data() {
    return {
      disabled: false,
      logs: [],
      loading: false,
      searchTerm: '',
      selectedOrigem: 'all',
      selectedEvento: 'all',
      filterUsuarioId: '',
      filterDataInicio: '',
      filterDataFim: '',
      autoRefresh: false,
      refreshInterval: null,
      currentPage: 1,
      pageSize: 20,
      totalRecords: 0,
      totalPages: 0,
    };
  },
  computed: {},
  mounted() {
    this.loadLogs();
  },
  beforeUnmount() {
    if (this.refreshInterval) {
      clearInterval(this.refreshInterval);
    }
  },
  methods: {
    async loadLogs() {
      this.loading = true;
      try {
        const params = new URLSearchParams({
          page: this.currentPage,
          limit: this.pageSize
        });
        
        if (this.selectedOrigem !== 'all') {
          params.append('origem', this.selectedOrigem);
        }
        if (this.selectedEvento !== 'all') {
          params.append('evento', this.selectedEvento);
        }
        if (this.filterUsuarioId) {
          params.append('usuario_id', this.filterUsuarioId);
        }
        if (this.filterDataInicio) {
          params.append('data_inicio', this.filterDataInicio);
        }
        if (this.filterDataFim) {
          params.append('data_fim', this.filterDataFim);
        }
        if (this.searchTerm) {
          params.append('search', this.searchTerm);
        }
        
        const response = await LogsApi.getAllList(params.toString())
        const data = response.data;
        
        if (data.status === 200 && data.data) {
          this.logs = data.data.map(log => ({
            ...log,
            showDetails: false
          }));
          
          if (data.pagination) {
            this.currentPage = data.pagination.current_page;
            this.totalRecords = data.pagination.total;
            this.totalPages = data.pagination.total_pages;
          }
        }
      } catch (error) {
        console.error('Erro ao carregar logs:', error);
        alert('Erro ao carregar logs. Verifique o console.');
      } finally {
        this.loading = false;
      }
    },
    
    applyFilters() {
      this.currentPage = 1;
      this.loadLogs();
    },

    clearFilters() {
      this.searchTerm = '';
      this.selectedOrigem = 'all';
      this.selectedEvento = 'all';
      this.filterUsuarioId = '';
      this.filterDataInicio = '';
      this.filterDataFim = '';
      this.currentPage = 1;

      this.loadLogs();
    },
    
    goToPage(page) {
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        this.loadLogs();
      }
    },
    
    changePageSize() {
      this.currentPage = 1;
      this.loadLogs();
    },
    
    toggleDetails(log) {
      log.showDetails = !log.showDetails;
      this.$forceUpdate();
    },    
    formatTime(timestamp) {
      return new Date(timestamp).toLocaleString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit'
      });
    },

    explicacaoOrigem(origem){
      const origens = {
        "WEB": "Foram realizadas ações via aplicação e agrupados em um só ação. ex: Novo item, edição de item...",
        "API": "A Api foi chamada, pode ter origem em outra ação porém na maioria das vezes é acionada de forma externa.",
        "MODEL": "Ação sem origem definida, tanto pode ser via web ou api, nesse caso você pode usar o trace para mais detalhes!",
      }
      return origens[origem] || origem;
    },
    
    formatEvento(evento) {
      const eventos = {
        'EDIT_ORCAMENTO': 'Edição de Orçamento',
        'EDIT_ORCAMENTO_ITEM': 'Edição de Item',
        'NOVO_ORCAMENTO_ITEM': 'Novo Item',
        'CANCELAMENTO_ORCAMENTO': 'Cancelamento de Orçamento',
        'DELETE_ORCAMENTO_ITEM': 'Item Deletado',
        'PRE_EDIT_ORCAMENTO_ITEM_MARGEM': 'Item Pré Editado',

        'SALVAR_ORCAMENTO': 'Edição de Orçamento',
        'ALTERAR_IPI_ST_ORCAMENTO': 'Edição de Orçamento ST IPI',

        'ATUALIZAR_MARGEM_ST_ITEM': 'Edição item Margem ST',
        'ATUALIZAR_MARGEM_PERCENTUAL_ITEM': 'Edição item Margem %',
        'ATUALIZAR_MARGEM_VALOR_ITEM': 'Edição item Margem R$',

        'ATUALIZAR_IPI_ST_ITEM': 'Edição item IPI ST'
      };
      return eventos[evento] || evento;
    },
    
    formatContext(contexto) {
      try {
        return JSON.stringify(JSON.parse(contexto), null, 2);
      } catch {
        return contexto;
      }
    },
    
    getLogSummary(log) {
      try {
        const context = JSON.parse(log.contexto);
        
        if (log.evento === 'CANCELAMENTO_ORCAMENTO') {
          const automatico = context.AUTOMATICO === 'S' ? 'Automático' : 'Manual';
          return `${automatico} - Orçamento #${context.orcamento_id} - Motivo: ${context.motivo}`;
        }
        
        if (log.evento === 'EDIT_ORCAMENTO_ITEM') {
          const antes = context.antes;
          const depois = context.depois;
          const changes = [];

          Object.keys(depois).forEach((key) => {
            if (antes[key] != depois[key]) {
              changes.push(`${key}: ${antes[key]} → ${depois[key]}`);
            }
          });

          return `Item #${depois.id}${changes.length ? ' - ' + changes.join(' | ') : ''}`;
        }

        if (log.evento === 'DELETE_ORCAMENTO_ITEM'){
            return `Item #${context.id}`
        }

        if (log.evento === 'SALVAR_ORCAMENTO'){
            return `Alterado: ${(context.affected_rows == 1)? 'Sim' : 'Não'} - Orçamento: ${context.orcamento_id}`
        }

        if (log.evento === 'ATUALIZAR_MARGEM_ST_ITEM'){
            return `Alterado: ${(context.affected_rows == 1)? 'Sim' : 'Não'} - Orçamento: ${context.orcamento_id} - Item: ${context.produto_codigo}`
        }

        if (log.evento === 'ATUALIZAR_MARGEM_PERCENTUAL_ITEM'){
            return `Alterado: ${(context.affected_rows == 1)? 'Sim' : 'Não'} - Orçamento: ${context.orcamento_id}`
        }

        if (log.evento === 'ATUALIZAR_MARGEM_VALOR_ITEM'){
            return `Alterado: ${(context.affected_rows == 1)? 'Sim' : 'Não'} - Orçamento: ${context.orcamento_id}`
        }

        if (log.evento === 'ATUALIZAR_IPI_ST_ITEM'){
            return `Alterado: ${(context.affected_rows == 1)? 'Sim' : 'Não'} - Orçamento: ${context.orcamento_id}`
        }

         if (log.evento === 'ALTERAR_IPI_ST_ORCAMENTO'){
            return `Alterado: ${(context.affected_rows == 1)? 'Sim' : 'Não'} - Orçamento: ${context.orcamento_id} - Item: ${context.produto_codigo}`
        }
        
        if (log.evento === 'EDIT_ORCAMENTO') {
          const antes = context.antes;
          const depois = context.depois;
          const changes = [];
          
          if (antes.observacao !== depois.observacao) {
            changes.push(`Observação alterada`);
          }
          if (antes.id_forma !== depois.id_forma) {
            changes.push(`Forma pagamento: ${antes.id_forma} → ${depois.id_forma}`);
          }
          if (antes.id_condicao !== depois.id_condicao) {
            changes.push(`Condição: ${antes.id_condicao} → ${depois.id_condicao}`);
          }
          if (antes.previsao_fechamento !== depois.previsao_fechamento) {
            changes.push(`Previsão fechamento alterada`);
          }
          
          return changes.length > 0 ? 
            `Orçamento #${depois.id} - ${changes.join(' | ')}` : 
            `Orçamento #${depois.id} modificado`;
        }
        
        return '';
      } catch {
        return 'Erro ao processar contexto';
      }
    },
    
    countByOrigem(origem) {
      return this.logs.filter(log => log.origem === origem).length;
    },
    
    countByEvento(evento) {
      return this.logs.filter(log => log.evento === evento).length;
    },
    
    exportLogs() {
      const params = new URLSearchParams();
      
      if (this.selectedOrigem !== 'all') {
        params.append('origem', this.selectedOrigem);
      }
      if (this.selectedEvento !== 'all') {
        params.append('evento', this.selectedEvento);
      }
      if (this.filterUsuarioId) {
        params.append('usuario_id', this.filterUsuarioId);
      }
      if (this.filterDataInicio) {
        params.append('data_inicio', this.filterDataInicio);
      }
      if (this.filterDataFim) {
        params.append('data_fim', this.filterDataFim);
      }
      if (this.searchTerm) {
        params.append('search', this.searchTerm);
      }
      
      const dataStr = JSON.stringify(this.logs, null, 2);
      const dataBlob = new Blob([dataStr], { type: 'application/json' });
      const url = URL.createObjectURL(dataBlob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `logs_${new Date().toISOString().split('T')[0]}.json`;
      link.click();
      URL.revokeObjectURL(url);
    }
  },
};
</script>

<style scoped>
.logs-container {
  padding: 20px;
  max-width: 1600px;
  margin: 0 auto;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

.logs-header h2 {
  margin: 0 0 20px 0;
  color: #333;
}

.controls {
  display: flex;
  gap: 15px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.search-box {
  flex: 1;
  min-width: 250px;
}

.search-input {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
}

.filters {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.filter-select, .filter-input {
  padding: 10px 15px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 14px;
  background: white;
}

.filter-select {
  cursor: pointer;
}

.filter-input {
  width: 120px;
}

.action-buttons {
  display: flex;
  gap: 10px;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
}

.btn-primary {
  background: #007bff;
  color: white;
}

.btn-primary:hover:not(:disabled) {
  background: #0056b3;
}

.btn-secondary {
  background: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background: #545b62;
}

.btn-success {
  background: #28a745;
  color: white;
}

.btn-success:hover {
  background: #218838;
}

.btn-warning{
  background: #db5050;
  color: white;
}

.btn-warning:hover{
  background: #bb3f3f;
}

.btn-info {
  background: #17a2b8;
  color: white;
}

.btn-info:hover {
  background: #138496;
}

.btn-sm {
  padding: 8px 16px;
  font-size: 13px;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.logs-stats {
  display: flex;
  gap: 20px;
  margin-bottom: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 6px;
  flex-wrap: wrap;
}

.stat {
  font-size: 14px;
  font-weight: 600;
  color: #333;
}

.stat.web { color: #007bff; }
.stat.model { color: #007bff; }
.stat.api { color: #6f42c1; }
.stat.evento { color: #17a2b8; }
.stat.cancelamento { color: #dc3545; }

.logs-content {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 6px;
  max-height: 700px;
  overflow-y: auto;
}

.loading, .no-logs {
  padding: 40px;
  text-align: center;
  color: #999;
}

.log-entry {
  padding: 15px;
  border-bottom: 1px solid #eee;
  transition: background 0.2s;
}

.log-entry:hover {
  background: #f8f9fa;
}

.log-entry.origem-web {
  border-left: 4px solid #007bff;
}

.log-entry.origem-model {
  border-left: 4px solid #6f42c1;
}

.log-entry.origem-api {
  border-left: 4px solid #6f42c1;
}

.log-entry.origem-mobile {
  border-left: 4px solid #28a745;
}

.log-header {
  display: flex;
  gap: 15px;
  align-items: center;
  margin-bottom: 10px;
  font-size: 13px;
  flex-wrap: wrap;
}

.log-id {
  color: #999;
  font-weight: 600;
  font-family: monospace;
}

.log-time {
  color: #666;
  font-family: monospace;
}

.size-6{
    width: 20px;
    height: 20px;
}

.log-origem {
  padding: 3px 10px;
  border-radius: 3px;
  font-weight: 600;
  font-size: 11px;
  text-transform: uppercase;
}

.log-origem.web {
  background: #007bff;
  color: white;
}

.log-origem.model {
  background: #5804ca;
  color: white;
}


.log-origem.api {
  background: #6f42c1;
  color: white;
}

.log-origem.mobile {
  background: #28a745;
  color: white;
}

.log-evento {
  color: #666;
  font-weight: 500;
  font-size: 13px;
}

.log-info {
  display: flex;
  gap: 20px;
  margin-bottom: 10px;
  font-size: 12px;
  color: #666;
}

.info-item strong {
  color: #333;
}

.log-message {
  color: #333;
  line-height: 1.5;
  margin-bottom: 10px;
  font-size: 14px;
}

.log-details {
  margin-top: 15px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 4px;
  border: 1px solid #e9ecef;
}

.details-header {
  margin-bottom: 10px;
  color: #495057;
  font-size: 13px;
}

.log-details pre {
  margin: 0;
  font-family: 'Courier New', monospace;
  font-size: 12px;
  color: #495057;
  overflow-x: auto;
  max-height: 300px;
}

.btn-toggle-details {
  margin-top: 10px;
  padding: 6px 12px;
  background: #e9ecef;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 12px;
  color: #495057;
  transition: all 0.2s;
}

.btn-toggle-details:hover {
  background: #dee2e6;
}

.pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
  padding: 15px;
  flex-wrap: wrap;
}

.page-info {
  font-size: 14px;
  color: #666;
}

.page-size-select {
  padding: 8px 12px;
  border: 1px solid #ddd;
  border-radius: 6px;
  font-size: 13px;
  background: white;
  cursor: pointer;
}
</style>